import { createSlice } from "@reduxjs/toolkit";

const appTitanSlice = createSlice({
  name: "appTitan",
  initialState: { ignoreMobile: false },
  reducers: {
    setIgnoreMobile: (state, action) => {
      state.ignoreMobile = action.payload;
    },
  },
});

export const { setIgnoreMobile } = appTitanSlice.actions;

export default appTitanSlice.reducer;

export const selectIgnoreMobile = (state) => state.appTitan.ignoreMobile;
